/*
 * Ryan O'Dowd
 * 2025-05-23
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors, isDarkMode}) => {
  return {
    ringsWrapper: {
      flexGrow: 1,
      justifyContent: 'center',
      alignItems: 'center',
    },
    streakWarningWrapper: {
      position: 'absolute',
      top: 4,
      left: 4,
    },
    streakWarningIcon: {
      color: colors.warnIncorrect, // @TODO: dynamic for different themes // @TODO: animate it slowly? maybe like a rotating gradient instead of a single color
      fontSize: globalScale * 32,
    },
    sectionTitle: { // @TODO: in the dialog...could probably be in commonStyles // @TODO: duplicated in other widgets...move to widgetbase?
      marginTop: globalScale * 16,
      fontSize: globalScale * 16,
      fontFamily: fonts.secondaryBold,
      color: isDarkMode ? colors.white : colors.black,
    },
    sectionWrapper: { // @TODO: in the dialog...could probably be in commonStyles // @TODO: duplicated in other widgets...move to widgetbase?
      padding: 8,
      paddingTop: 0,
    },
    goalSettingsWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around',
      marginTop: 4,
    },
    goalSettingsRow: {
      width: '20%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    labelText: {
      fontSize: globalScale * 14,
      color: isDarkMode ? colors.white : colors.black,
    },
  };
};

export default getStyles;
